define((require) => {
    "use strict";

    var Marionette          = require("marionette"),
        ViewScope           = require("shared/ui/common/ViewScope");

    /**
     * CompositeView that supports the view scope concept.
     *
     * @class ImprovedCompositeView
     */
    return Marionette.CompositeView.extend({

        renderItemView: function(view, index) {
            view.parentView = this;
            ViewScope.register(this, view);
            Marionette.CollectionView.prototype.renderItemView.call(this, view, index);
        },

        appendHtml: function(compositeView, itemView, index) {
            if (compositeView.isBuffering) {
                compositeView.elBuffer.appendChild(itemView.el);
                compositeView._bufferedChildren.push(itemView);
            } else {
                // If we've already rendered the main collection, just
                // append the new items directly into the container.
                var $container = this.getItemViewContainer(compositeView);

                var classFilter = itemView.className ? "." + itemView.className : "",
                    $children = $container.find(classFilter);

                if (index >= 0 && $children.length) {
                    if (index === 0) {
                        $children.eq(0).before(itemView.el);
                    } else {
                        $children.eq(index - 1).after(itemView.el);
                    }
                } else {
                    $container.append(itemView.el);
                }
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/zbone/ImprovedCompositeView.js